angular.module('inspinia').directive('baseTextarea', () => {
  return {
    restrict: 'E',
    scope: {
      name: '=',
      placeholder: '=',
      type: '=',
      cols: '@',
      rows: '@',
      ngModel: '=',
      ngDisabled: '=?',
    },
    transclude: true,
    templateUrl: `/manage/src/view/directive/base_textarea.html?${new Date().getTime()}`,
    link($scope) {
      $scope.ngDisabled || false;
      $scope.placeholder || '';
      $scope.type || 'primary';
      $scope.cols || 30;
      $scope.col || 40;
      /**
       * CSSのクラス名を返す
       * @returns {object} textareaの状態を示すクラス
       */
      $scope.baseTextareaClasses = () => {
        let classes = {};
        if ($scope.ngDisabled) {
          classes[`anglrC-textarea--disabled`] = true;
        } else if ($scope.type === 'alert') {
          classes[`anglrC-textarea--alert`] = true;
        } else {
          classes[`anglrC-textarea`] = true;
        }
        return classes;
      };
    },
  };
});
